/**
 * This enum is used for the health-check information
 */
export enum ChatbotSettingsEnum {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED'
}
